/**
 * Handles fixed header functionality
 * @module fixedHeader
 */
import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'fixedHeader';

export const DEFAULTS = {

};
/**
 * Set Event setEventListeners
 * @param  {jQuery} $el - header element
 */
const scrollEventHandler = () => {
  // code below needs to be refactored
  const $headerWrapper = $('.js-site-header__wrapper');
  let lastScrollTop = 0;
  let headerPosition = 0;
  $(window).scroll(function srollHandler() {
    const st = $(this).scrollTop();
    const top = st * -1;
    const scrollDiff = 400;
    const diffPosition = top - lastScrollTop;
    headerPosition += diffPosition;
    if (headerPosition < -scrollDiff && diffPosition < 0) {
      headerPosition = -scrollDiff;
    } else if (headerPosition > 0) {
      headerPosition = 0;
    }
    // Conditional below is to fix a bug on Safari
    if (top > 0) {
      headerPosition = 0;
    }
    $headerWrapper.css({ transform: `translate3d(0px, ${headerPosition}px, 0px)` });
    lastScrollTop = top;
    // console.log(headerPosition, scrollDiff, diffPosition, top);
  });
};
/**
 * Apply Event Handlers
 * @param  {jQuery} $el - dropdown wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = ($el, opts) => {
  scrollEventHandler($el, opts);
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - dropdown wrap
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function fixedHeader(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, fixedHeader);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-header.js